<div
  class="activity-mgmt flex flex-col min-h-[calc(100vh-100px)] w-full bg-[#F7FAFC] font-['Archivo',sans-serif] px-[24px] md:px-[32px] lg:px-[40px] pt-[24px] pb-[32px]">
  <div *ngIf="isInitialLoading" class="flex flex-col items-center justify-center w-full py-[80px] gap-4">
    <div class="loader-spinner w-12 h-12 border-4 border-[#f26f24ff] border-t-transparent rounded-full animate-spin"></div>
    <span class="text-[#111215] text-[18px]">Loading...</span>
  </div>

  <ng-container *ngIf="!isInitialLoading">
    <div
      class="activity-mgmt__panel w-full bg-white rounded-[12px] border border-[#EAECF0] shadow-[0_1px_3px_rgba(16,24,40,0.08),0_1px_2px_rgba(16,24,40,0.06)] p-[24px] flex flex-col gap-[20px]">
      <div class="flex flex-row flex-wrap items-center justify-between gap-[16px]">
        <div class="flex flex-row items-center gap-[16px]">
          <button
            type="button"
            class="activity-mgmt__back-btn"
            (click)="goBack()"
            aria-label="Back">
            <svg
              class="activity-mgmt__back-icon"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true">
              <path
                d="M20 12H4M4 12L10 18M4 12L10 6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Back</span>
          </button>
          <h1 class="activity-mgmt__title">
            Activity
          </h1>
        </div>

        <div class="flex flex-row flex-wrap items-center gap-[12px] justify-end">
          <div class="activity-mgmt__search relative w-[220px]">
            <input
              type="search"
              class="w-full h-[40px] rounded-[8px] border border-[#D0D5DD] bg-white pl-[12px] pr-[40px] text-[14px] font-normal leading-[20px] text-[#101828] placeholder:text-[#98A2B3] outline-none focus:border-[#F26F24]"
              placeholder="Search..."
              [ngModel]="searchText"
              (ngModelChange)="onSearchInput($event)"
              aria-label="Search activities" />
            <img
              src="assets/icons/search_md.svg"
              alt=""
              class="absolute right-[12px] top-1/2 -translate-y-1/2 w-[16px] h-[16px] opacity-60 pointer-events-none" />
          </div>

          <!-- Figma: secondary grey outline — funnel icon + Filter + chevron -->
          <button
            type="button"
            class="activity-mgmt__toolbar-btn activity-mgmt__toolbar-btn--secondary inline-flex items-center gap-[8px] h-[40px] px-[14px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] cursor-pointer hover:bg-[#F9FAFB]"
            (click)="toggleFilterPanel()"
            [attr.aria-expanded]="isFilterOpen">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M4 5h16l-6.5 7.5V19l-3 1.5v-8L4 5z"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linejoin="round" />
            </svg>
            <span>Filter</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
              class="activity-mgmt__toolbar-chevron"
              [class.activity-mgmt__toolbar-chevron--open]="isFilterOpen">
              <path
                d="M6 9l6 6 6-6"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>

          <button
            type="button"
            class="activity-mgmt__toolbar-btn activity-mgmt__toolbar-btn--secondary inline-flex items-center gap-[8px] h-[40px] px-[14px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] cursor-pointer hover:bg-[#F9FAFB]"
            title="Download the current activity list as Excel"
            (click)="onDownload()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M12 3V15M12 15L16 11M12 15L8 11M4 17V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V17"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            Download
          </button>

          <button
            type="button"
            class="activity-mgmt__toolbar-btn activity-mgmt__toolbar-btn--accent inline-flex items-center gap-[8px] h-[40px] px-[14px] rounded-[8px] border border-[#F26F24] bg-white text-[#F26F24] cursor-pointer hover:bg-[#FFF3EA]"
            (click)="openBulkUploadModal()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
              <path d="M12 16V4M12 4l-4 4M12 4l4 4" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" stroke-linecap="round" />
            </svg>
            Bulk Upload
          </button>

          <button
            type="button"
            class="activity-mgmt__toolbar-btn activity-mgmt__toolbar-btn--primary inline-flex items-center gap-[6px] h-[40px] px-[16px] rounded-[8px] border-0 bg-[#F26F24] text-white cursor-pointer hover:bg-orange-600"
            (click)="onAddActivity()">
            + Add Activity
          </button>
        </div>
      </div>

      <div *ngIf="errorMessage" class="text-red-600 text-[14px]">
        {{ errorMessage }}
      </div>

      <div class="activity-mgmt__table w-full">
        <NiTable
          *ngIf="!errorMessage"
          [columns]="columns"
          [data]="filteredList"
          trackByKey="id"
          [pagination]="true"
          [pageSize]="10"
          emptyMessage="No activities found."
        >
          <ng-template niTableCell="special" let-row="row">
            <!-- Figma: Yes = circle outline + check; No = empty circle (never hyphen) -->
            <span
              *ngIf="row.special"
              class="inline-flex items-center justify-center"
              aria-label="Special activity: Yes">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="12" cy="12" r="9" stroke="#333740" stroke-width="1.75" />
                <path
                  d="M8.2 12.2 10.7 14.7 15.8 9.4"
                  stroke="#333740"
                  stroke-width="1.75"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            <span
              *ngIf="!row.special"
              class="inline-flex items-center justify-center"
              aria-label="Special activity: No">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="12" cy="12" r="9" stroke="#98A2B3" stroke-width="1.75" />
              </svg>
            </span>
          </ng-template>

          <ng-template niTableCell="action" let-row="row">
            <div class="relative inline-flex justify-center" (click)="$event.stopPropagation()">
              <button
                type="button"
                class="w-[32px] h-[32px] rounded-[6px] border-0 bg-transparent cursor-pointer hover:bg-[#F2F4F7] text-[#475467] text-[18px] leading-none"
                (click)="toggleActionMenu(row.id, $event)"
                aria-label="Open row actions">
                ⋮
              </button>
              <div
                *ngIf="openActionMenuId === row.id"
                class="absolute right-0 top-[36px] z-20 min-w-[140px] rounded-[8px] border border-[#EAECF0] bg-white shadow-[0_8px_20px_rgba(16,24,40,0.12)] py-[4px]">
                <button type="button" class="activity-mgmt__menu-item" (click)="onEdit(row)">Edit</button>
                <button
                  type="button"
                  class="activity-mgmt__menu-item"
                  [disabled]="isDuplicating"
                  (click)="onDuplicate(row)">
                  {{ isDuplicating && duplicatingId === row.id ? 'Duplicating…' : 'Duplicate' }}
                </button>
                <!-- Draft: no Active/Inactive. Active → show Inactive; Inactive → show Active. -->
                <button
                  *ngIf="canToggleStatus(row)"
                  type="button"
                  class="activity-mgmt__menu-item"
                  (click)="onToggleStatus(row)">
                  {{ statusToggleLabel(row) }}
                </button>
              </div>
            </div>
          </ng-template>
        </NiTable>
      </div>
    </div>
  </ng-container>

  <div
    *ngIf="isFilterOpen"
    class="activity-mgmt__overlay fixed inset-0 z-40 bg-black/20"
    (click)="closeFilterPanel()"></div>

  <aside
    *ngIf="isFilterOpen"
    class="activity-mgmt__filter fixed top-0 right-0 z-50 h-full w-full max-w-[360px] bg-white shadow-[-8px_0_24px_rgba(16,24,40,0.12)] flex flex-col"
    role="dialog"
    aria-label="Filter activities">
    <div class="flex items-center justify-between px-[24px] py-[20px] border-b border-[#EAECF0]">
      <h2 class="m-0 text-[20px] font-bold text-[#101828]">Filter</h2>
      <button
        type="button"
        class="w-[36px] h-[36px] rounded-[8px] border-0 bg-transparent cursor-pointer text-[22px] leading-none text-[#475467] hover:bg-[#F2F4F7]"
        (click)="closeFilterPanel()"
        aria-label="Close filter">
        ×
      </button>
    </div>

    <div class="flex-1 overflow-y-auto px-[24px] py-[20px] flex flex-col gap-[20px]">
      <label class="flex flex-col gap-[6px]">
        <span class="text-[14px] font-medium text-[#344054]">Activity</span>
        <select
          class="h-[44px] rounded-[8px] border border-[#D0D5DD] px-[14px] pr-[36px] text-[14px] outline-none focus:border-[#F26F24] bg-white cursor-pointer"
          [(ngModel)]="filterActivity">
          <option value="">Select</option>
          <option *ngFor="let activity of activityOptions" [value]="activity">{{ activity }}</option>
        </select>
      </label>

      <div class="flex flex-col gap-[6px]">
        <span class="text-[14px] font-medium text-[#344054]">Type</span>
        <div class="flex flex-wrap gap-[8px] min-h-[44px] rounded-[8px] border border-[#D0D5DD] px-[10px] py-[8px] bg-white">
          <span
            *ngFor="let type of filterTypes"
            class="inline-flex items-center gap-[6px] rounded-full bg-[#F4EBFF] text-[#6941C6] px-[10px] py-[4px] text-[13px] font-medium">
            {{ type }}
            <button type="button" class="border-0 bg-transparent cursor-pointer text-[#6941C6] p-0" (click)="removeType(type)" aria-label="Remove {{ type }}">×</button>
          </span>
          <select
            class="border-0 outline-none text-[14px] text-[#667085] bg-transparent grow min-w-[120px]"
            (change)="toggleType($any($event.target).value); $any($event.target).value = ''">
            <option value="" disabled selected>Add type</option>
            <option *ngFor="let option of typeOptions" [value]="option" [disabled]="filterTypes.includes(option)">
              {{ option }}
            </option>
          </select>
        </div>
      </div>

      <fieldset class="border-0 p-0 m-0 flex flex-col gap-[8px]">
        <legend class="text-[14px] font-medium text-[#344054] mb-[4px]">Special Activity</legend>
        <div class="flex flex-row gap-[16px]">
          <label class="inline-flex items-center gap-[8px] text-[14px] text-[#344054] cursor-pointer">
            <input type="radio" name="specialEvent" value="yes" [(ngModel)]="filterSpecialEvent" />
            Yes
          </label>
          <label class="inline-flex items-center gap-[8px] text-[14px] text-[#344054] cursor-pointer">
            <input type="radio" name="specialEvent" value="no" [(ngModel)]="filterSpecialEvent" />
            No
          </label>
        </div>
      </fieldset>

      <fieldset class="border-0 p-0 m-0 flex flex-col gap-[8px]">
        <legend class="text-[14px] font-medium text-[#344054] mb-[4px]">Activity Schedule</legend>
        <div class="flex flex-col gap-[10px]">
          <label *ngFor="let option of reoccurringOptions" class="inline-flex items-center gap-[8px] text-[14px] text-[#344054] cursor-pointer">
            <input
              type="checkbox"
              [checked]="filterReoccurring.includes(option)"
              (change)="toggleReoccurring(option)" />
            {{ option }}
          </label>
        </div>
      </fieldset>

      <label class="flex flex-col gap-[6px]">
        <span class="text-[14px] font-medium text-[#344054]">Domains of Wellness</span>
        <select
          class="h-[44px] rounded-[8px] border border-[#D0D5DD] px-[14px] text-[14px] outline-none focus:border-[#F26F24] bg-white"
          [(ngModel)]="filterDomain">
          <option value="">Select</option>
          <option *ngFor="let domain of domainOptions" [value]="domain">{{ domain }}</option>
        </select>
      </label>

      <div class="flex flex-col gap-[6px]">
        <span class="text-[14px] font-medium text-[#344054]">Date Range</span>
        <div class="flex flex-col gap-[8px]">
          <input
            type="date"
            class="h-[44px] rounded-[8px] border border-[#D0D5DD] bg-white px-[14px] text-[14px] outline-none focus:border-[#F26F24]"
            [(ngModel)]="filterFromDate"
            aria-label="From date" />
          <input
            type="date"
            class="h-[44px] rounded-[8px] border border-[#D0D5DD] bg-white px-[14px] text-[14px] outline-none focus:border-[#F26F24]"
            [(ngModel)]="filterToDate"
            aria-label="To date" />
        </div>
      </div>
    </div>

    <div class="px-[24px] py-[20px] border-t border-[#EAECF0] flex flex-row items-center justify-end gap-[12px]">
      <button
        type="button"
        class="h-[40px] px-[18px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] text-[14px] font-semibold cursor-pointer hover:bg-[#F9FAFB]"
        (click)="resetFilters()">
        Reset
      </button>
      <button
        type="button"
        class="h-[40px] px-[22px] rounded-[8px] border-0 bg-[#F26F24] text-white text-[14px] font-semibold cursor-pointer hover:bg-orange-600"
        (click)="applyFilters()">
        APPLY
      </button>
    </div>
  </aside>

  <div
    *ngIf="isBulkUploadOpen"
    class="activity-mgmt__overlay fixed inset-0 z-40 bg-black/30"
    (click)="closeBulkUploadModal()"></div>

  <div
    *ngIf="isBulkUploadOpen"
    class="activity-mgmt__bulk-modal fixed left-1/2 top-1/2 z-50 w-[calc(100%-32px)] max-w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-[12px] border border-[#EAECF0] bg-white shadow-[0_20px_40px_rgba(16,24,40,0.16)]"
    role="dialog"
    aria-modal="true"
    aria-labelledby="bulk-upload-title"
    (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between px-[24px] py-[18px] border-b border-[#EAECF0]">
      <h2 id="bulk-upload-title" class="m-0 text-[20px] font-bold text-[#101828]">Bulk Upload</h2>
      <button
        type="button"
        class="w-[36px] h-[36px] rounded-[8px] border-0 bg-transparent cursor-pointer text-[22px] leading-none text-[#475467] hover:bg-[#F2F4F7]"
        (click)="closeBulkUploadModal()"
        aria-label="Close bulk upload">
        ×
      </button>
    </div>

    <div class="px-[24px] py-[20px] flex flex-col gap-[20px]">
      <p class="m-0 text-[14px] leading-[20px] text-[#667085]">
        Download the activity template, fill in the Create Activity fields, then upload the completed CSV or Excel file.
      </p>

      <div class="rounded-[10px] border border-[#EAECF0] bg-[#F9FAFB] px-[16px] py-[14px] flex flex-col gap-[10px]">
        <span class="text-[14px] font-semibold text-[#101828]">1. Download template</span>
        <span class="text-[13px] leading-[18px] text-[#667085]">
          Excel template with dropdowns for Type, Center, Time, Reoccurring, and related fields. Limited Capacity is a free number (any whole value). Domains of Wellness are not in the import — they are set automatically from Type.
        </span>
        <button
          type="button"
          class="inline-flex items-center justify-center gap-[8px] self-start h-[40px] px-[14px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] text-[14px] font-semibold cursor-pointer hover:bg-[#F9FAFB]"
          (click)="downloadBulkTemplate()">
          <img src="assets/icons/download.svg" alt="" class="w-[16px] h-[16px]" />
          Download Template
        </button>
      </div>

      <div class="rounded-[10px] border border-[#EAECF0] bg-[#F9FAFB] px-[16px] py-[14px] flex flex-col gap-[10px]">
        <span class="text-[14px] font-semibold text-[#101828]">2. Upload completed file</span>
        <span class="text-[13px] leading-[18px] text-[#667085]">
          Accepts .csv, .xlsx, or .xls.
        </span>
        <div class="flex flex-row flex-wrap items-center gap-[10px]">
          <button
            type="button"
            class="inline-flex items-center gap-[8px] h-[40px] px-[14px] rounded-[8px] border border-[#F26F24] bg-white text-[#F26F24] text-[14px] font-semibold cursor-pointer hover:bg-[#FFF3EA]"
            (click)="triggerBulkFilePicker()">
            Choose File
          </button>
          <span class="text-[13px] text-[#475467]">
            {{ bulkSelectedFileName || 'No file selected' }}
          </span>
        </div>
        <input
          #bulkFileInput
          type="file"
          class="hidden"
          accept=".csv,.xlsx,.xls,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          (change)="onBulkFileSelected($event)" />
      </div>

      <div *ngIf="bulkErrorMessage" class="text-red-600 text-[13px] leading-[18px]">
        {{ bulkErrorMessage }}
      </div>
      <div *ngIf="bulkSuccessMessage" class="text-green-700 text-[13px] leading-[18px]">
        {{ bulkSuccessMessage }}
      </div>
      <ul *ngIf="bulkRowErrors.length" class="m-0 pl-[18px] flex flex-col gap-[4px] text-[13px] text-[#B42318]">
        <li *ngFor="let err of bulkRowErrors">
          Row {{ err.row }}{{ err.activityName ? ' (' + err.activityName + ')' : '' }}: {{ err.message }}
        </li>
      </ul>
    </div>

    <div class="px-[24px] py-[16px] border-t border-[#EAECF0] flex flex-row items-center justify-end gap-[12px]">
      <button
        type="button"
        class="h-[40px] px-[18px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] text-[14px] font-semibold cursor-pointer hover:bg-[#F9FAFB]"
        [disabled]="isBulkUploading"
        (click)="closeBulkUploadModal()">
        Cancel
      </button>
      <button
        type="button"
        class="h-[40px] px-[22px] rounded-[8px] border-0 bg-[#F26F24] text-white text-[14px] font-semibold cursor-pointer hover:bg-orange-600 disabled:opacity-60 disabled:cursor-not-allowed"
        [disabled]="isBulkUploading || !bulkSelectedFile"
        (click)="submitBulkUpload()">
        {{ isBulkUploading ? 'Uploading…' : 'Upload' }}
      </button>
    </div>
  </div>
</div>
